<template>
  <div>
    <h2 class="h2 text-light">Voorwaarden en betalen</h2>
    <h1 class="h1">Bijna klaar</h1>
    <div class="card">
      <div v-if="typeTransport === 'verhuizing'">
        <p class="margintop_0 bijnaText">Overschrijding van de geboekte tijd kost €40,00 per half uur per
            medewerker
        </p>
      </div>
      <p class="margintop_0 bijnaText" v-else>
        Door gebruik te maken van Logilist, ga je akkoord met de voorwaarden
          uit de vervoersovereenkomst.
      </p>
      <div class="form-group termsText">
        <input
          type="checkbox"
          id="newsletter"
          name="newsletter"
          v-model="newsletter"
        />
        <label for="newsletter"
          >Ja, houd me op de hoogte van updates en kortingen</label
        >
      </div>
      <div class="form-group termsText">
        <input
          type="checkbox"
          id="terms"
          v-on:change="checkterms()"
          name="terms"
          v-model="terms"
        />
        <label for="terms">
          Ik ga akkoord met de
          <a target="_blank" href="https://xxlcargo.nl/algemene-voorwaarden"
            >algemene voorwaarden</a
          >.*
        </label>
      </div>
      <div class="form-group termsText">
        <input
          type="checkbox"
          id="privacy"
          v-on:change="checkterms()"
          name="privacy"
          v-model="privacy"
        />
        <label for="privacy">
          Ik ga akkoord met het
          <a target="_blank" href="https://xxlcargo.nl/privacy-beleid"
            >privacy statement</a
          >.*
        </label>
      </div>

      <div class="error" v-if="$v.$error">
        U dient akkoord te gaan met de privacy statement en de algemene
        voorwaarden.
      </div>

      <div class="row-2">
        <!-- <button
          :disabled="pressed"
          @click="roundUp('offerte')"
          class="btn btn__filled btn__filled-grey btn__offraan w-100"
        >
          Offerte aanvragen
        </button> -->
        <button
          :disabled="isDisabled"
          @click="roundUp('betalen')"
          class="btn btn__filled w-100"
        >
          Afrekenen
        </button>
      </div>
    </div>
    <button
      @click="goToPreviousRoute"
      class="btn btn__simple btn__left btn__backbt"
    >
      <i class="fas fa-chevron-left"></i> Terug
    </button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Terms",
  data() {
    return {
      privacy: null,
      terms: null,
      pressed: false,
      isDisabled: true
    };
  },
  computed: {
    ...mapFields(["typeTransport", "newsletter"])
  },
  methods: {
    checkterms() {
      if (!this.privacy) {
        this.privacy = null;
      }

      if (!this.terms) {
        this.terms = null;
      }

      if (this.$v.$invalid) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    roundUp(type) {
      this.pressed = true;

      if (!this.privacy) {
        this.privacy = null;
      }

      if (!this.terms) {
        this.terms = null;
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.pressed = false;
        return;
      }

      fetch("https://api.xxlcargo.nl/api/prepare", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-token":
            "aGNwb3J0YWFsOmlvNDM0MjNoeTQzMmdmNDIzaGRzYmZzZG5uZ3l1NTRnM2g0MzJnaDQ="
        },
        body: JSON.stringify({
          data: this.$store.state,
          order: type,
          totalPrice: this.$parent.$refs.sidebar.totalPriceWithDiscount
        })
      })
        .then(response => response.json())
        .then(data => {
          window.sessionStorage.removeItem("vuex");
          location.href = data.data.redirectUrl;
        })
        .finally(() => {
          this.pressed = false;
        });
    }
  },
  validations: {
    privacy: {
      required
    },
    terms: {
      required
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 30px 40px;
  border: 1px solid var(--light-grey);
  margin-bottom: 10px;
}

.row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;
  margin-top: 24px;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr !important;
  }
}

.form-group {
  flex-direction: row;
  align-items: center;
  margin: 0;

  input {
    height: 28px;
    margin: 0;
    margin-right: 10px;
  }

  label {
    cursor: pointer;
    a {
      color: var(--black);
    }
  }
}

p {
  margin-top: 30px;
}
</style>
